import React, { useMemo, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AlyceHeader, { IAlyceHeaderProps } from '../../../../components/AlyceHeader/AlyceHeader';
import AlyceLogoSvg from '../../../../assets/images/alyce-logo.svg';
import { getBranding } from '../../../../store/branding/branding.selectors';
import { setConfirmedFlow } from '../../store/giftFlow/giftFlow.actions';

export interface IStyledHeaderProps extends IAlyceHeaderProps {
  onBackClick?: () => void;
}

const StyledHeader = ({ onBackClick, ...headerProps }: IStyledHeaderProps) => {
  const dispatch = useDispatch();
  const customStyling = useSelector(getBranding);
  const logo = customStyling.logoUrl || AlyceLogoSvg;

  const handleBack = useMemo(() => {
    if (!onBackClick) {
      return undefined;
    }
    return () => {
      dispatch(setConfirmedFlow(false));
      onBackClick();
    };
  }, [onBackClick, dispatch]);

  return <AlyceHeader image={logo} onBackClick={handleBack} {...headerProps} />;
};

export default memo(StyledHeader);
